<template>
  <div class="book-page-container">
    <TopNavbar title="书架"></TopNavbar>
    <Tabs type="card" color="#fc9153" v-model="selectedTab">
      <Tab title="最近阅读" :name="nameRecentRead"></Tab>
      <Tab title="书架" :name="nameBookShelf"></Tab>
    </Tabs>
    <div class="book-list-container" :key="selectedTab">
      <MixItemFeedLite :listType="selectedTab"></MixItemFeedLite>
    </div>
  </div>
</template>

<script>
  import TopNavbar from "../common/TopNavbar";
  import BookColumnFeed from "./BookColumnFeed";
  import {Tabs, Tab} from "vant"
  import MixItemFeedLite from "./MixItemFeedLite";

  export default {
    name: "BookShelfPage",
    components: {
      MixItemFeedLite,
      BookColumnFeed,
      TopNavbar,
      Tabs,
      Tab,
    },
    mounted() {
      if (this.$route.query.list_type) {
        this.selectedTab = this.$route.query.list_type
      } else {
        this.selectedTab = this.nameRecentRead
      }
    },
    data() {
      return {
        selectedTab: "",
        nameBookShelf: "book_shelf",
        nameRecentRead: "view_history"
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss" scoped>
  .book-page-container {
    padding-top: 54px;
    min-height: 100vh;
  }

  .book-list-container {
    margin-top: 4px;
  }

</style>
